export default {
  'salesCategory.title': '销售分类',
  'salesCategory.selectPlaceholder': '更多细节',
  'salesCategory.salesCategoryIsBrokenDownInto': '销售分类细分为',

  'salesCategory.edit.title': '编辑销售分类',
  'salesCategory.create.title': '创建销售分类',
  'salesCategory.add.dishes': '给销售分类添加菜品',

  'salesCategory.field.name': '名称',
  'salesCategory.field.foreign_name': '名称(中文)',
  'salesCategory.field.dishes': '菜品',
  'salesCategory.field.description': '描述',
  'salesCategory.field.foreign_description': '描述(中文)',

  'salesCategory.column.name': '名称',
  'salesCategory.column.itemName': '销售分类 > 菜品',
  'salesCategory.column.orderSourceAndServiceType': '销售分类 > 订单来源 & 服务类型',
  'salesCategory.column.serviceTypeAndOrderSource': '销售分类 > 服务类型 & 订单来源',
  'salesCategory.column.server': '销售分类 > 服务员',

  'salesCategory.column.sales_category': '名称',
  'salesCategory.column.item_qty': '菜品数量',
  'salesCategory.column.gross_sales_column': '销售额',
  'salesCategory.column.net_sales_column': '税前营业额',
  'salesCategory.column.discount_amount': '折扣',
  'salesCategory.column.tax_amount': '税额',
  'salesCategory.column.operation': '操作',

  'salesCategory.name.isRequired': '请输入销售分类',
  'salesCategory.foreign_name.isRequired': '请输入销售分类(中文)',

  'salesCategory.deletion.promptContent': '确认要删除此销售分类吗？',
  'salesCategory.action.editSalesCategory': '编辑销售分类',
  'salesCategory.action.setSalesCategory': '给分类设置',

  'salesCategory.methodForAddingDishes': '给销售分类添加菜品的方式:',
  'salesCategory.mode.setCategoryForSalesCategory': '在每个分类上设置它对应的销售分类',
  'salesCategory.mode.setCategoryForDishes': '给每个销售分类添加菜品',
  'salesCategory.modal.tip': '您确定切换？',
  'salesCategory.tips.01':
    '任何销售分类上的调整，仅对调整后的订单生效。所以如果您修改了销售分类的定义，之前的报表是不会发生变化的。',
  'salesCategory.tips.02': '如果您第一次使用销售分类，您可以联系我们的客服，来帮您回溯当月的历史数据，以更好的使用。',
  'salesCategory.add.dishes.menu.change.tip': '是否在切换前保存修改？',
};
